import { PIER_TUT_SET } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export interface pierTutSetState {
    loading: boolean
}

const initialState: pierTutSetState = {
    loading: false
}

export default function setPierTutStateReducer(state = initialState, action: AppAction) {
    const { value } = action;

    switch (action.type) {
        case PIER_TUT_SET:
            return {
                ...state,
                loading: value
            }
        default:
            return state;
    }
}